<template>
  <div class="modal-add-form">
    <modal v-model="opened" title="Créer une conversation" size="md" ok-text="Envoyer invitation" cancel-text="Annuler">
      <form v-if="form != null">
        <div class="form-group">
          <label for="adding-form-name">Nom de la conversation (Laisser vide pour liste des participants)</label>
          <input id="adding-form-name" type="text" ref="adding-form-name" v-model="form.chatroom_name" placeholder="Nom du chatroom..." class="form-control w-100">
        </div>
        <div class="form-group">
          <label for="">Liste des participants</label>
          <div>
            <div v-for="(participant, index) in form.participants" :key="index" class="participant-item p-2 mb-2">
              <div class="flex-grow-1">
                {{participant.user_name}}
              </div>
              <div>
                <button v-if="index > 0" class="btn red btn-sm" type="button" @click.prevent="deleteParticipant(index)"><i class="fa fa-trash"></i></button>
              </div>
            </div>
          </div>
          <div>
            <select-2
              class="mx-1" 
              placeholder="Choisir un utilisateur" 
              :endpoint="userSelect2Endpoint"
              @selected="userSelected($event)"
              :dropdownParent="'.modal-add-form .modal-dialog'" 
              :attributes="{selected_users: selectedUserIds}"
              ref="select-2"
            />
          </div>
        </div>
      </form>
      <div slot="footer">
        <btn @click="opened=false">Annuler</btn>
        <btn type="primary" @click="confirm" :disabled="confirming">Créer la conversation</btn>
      </div>
    </modal>
  </div>
</template>

<script>
import Select2 from '../Select2.vue';

export default {
  components: { Select2 },
  name: "chatroom-add-form",
  props: {
    form: {
      type: Object,
      require: true
    },
  },
  data() {
    return {
      opened: false,
      confirming: false
    }
  },
  computed: {
    userSelect2Endpoint() {
      return `${window.baseUrl}chatroom/select2/user_id`;
    },
    selectedUserIds() {
      return this.form.participants.map(p => p.user_id);
    }
  },
  methods: {
    open() {
      this.opened = true;
    },
    userSelected(evt) {
      this.form.participants.push(evt);
      this.$refs["select-2"].clearSelection();
    },
    confirm() {
      this.confirming = true;
      this.$emit("confirm", this.form);
    },
    dismiss() {
      this.opened = false;
      this.$refs["select-2"].clearSelection();
      this.confirming = false;
    },
    deleteParticipant(index) {
      this.form.participants.splice(index, 1);
    }
  },
}
</script>

<style lang="scss" scoped>
.participant-item {
  border: 1px solid #aaa;
  border-radius: 3px;
  display: flex;
  align-items: center;
}
</style>